import React from 'react';

const Store = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="25.018" height="29.7" viewBox="0 0 25.018 29.7">
      <g>
        <path d="M12.7,0A12.625,12.625,0,0,1,25,12.3a12.356,12.356,0,0,1-3.6,9.3l-7.6,7.6a1.656,1.656,0,0,1-1.2.5,1.845,1.845,0,0,1-1.2-.5L3.8,21.6a12.968,12.968,0,0,1-3.8-9A12.7,12.7,0,0,1,12.7,0Z" fill="#fff" />
        <path d="M12.7,1A11.9,11.9,0,0,0,4.4,4.4,11.5,11.5,0,0,0,1,12.6a11.36,11.36,0,0,0,3.5,8.2l7.6,7.6a.764.764,0,0,0,.5.2c.2,0,.3-.1.5-.2l7.6-7.6a11.534,11.534,0,0,0,3.4-8.5h0A11.784,11.784,0,0,0,12.7,1" fill="#08f" stroke="#231f20" strokeMiterlimit="10" strokeWidth="1" />
      </g>
      <g>
        <path d="M15.5,20.4h-6a2.689,2.689,0,0,1-2.7-2.7V8.8a.9.9,0,0,1,.9-.9h9.6a.9.9,0,0,1,.9.9v8.9A2.689,2.689,0,0,1,15.5,20.4Z" fill="#fff" stroke="#000" strokeMiterlimit="10" strokeWidth="1.5" />
        <path d="M9.7,10.5V6.1a2.689,2.689,0,0,1,2.7-2.7h.3a2.689,2.689,0,0,1,2.7,2.7v4.4" fill="none" stroke="#000" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1.5" />
      </g>
    </svg>
  )
};

export { Store };
